export class Extract {
  constructor(
    public table?: string,
    public view?: string,
  ) { }
}
